/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface ContentTag
 */
export interface ContentTag {
    /**
     * 
     * @type {string}
     * @memberof ContentTag
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ContentTag
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContentTag
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ContentTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContentTag
     */
    color?: string;
    /**
     * 
     * @type {Organization}
     * @memberof ContentTag
     */
    organization: Organization;
}

/**
 * Check if a given object implements the ContentTag interface.
 */
export function instanceOfContentTag(value: object): value is ContentTag {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    return true;
}

export function ContentTagFromJSON(json: any): ContentTag {
    return ContentTagFromJSONTyped(json, false);
}

export function ContentTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'name': json['name'],
        'color': json['color'] == null ? undefined : json['color'],
        'organization': OrganizationFromJSON(json['organization']),
    };
}

export function ContentTagToJSON(json: any): ContentTag {
    return ContentTagToJSONTyped(json, false);
}

export function ContentTagToJSONTyped(value?: ContentTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'name': value['name'],
        'color': value['color'],
        'organization': OrganizationToJSON(value['organization']),
    };
}

